import styled from 'styled-components';

import Box from '../box';


const HeaderRoot = styled.div`
	position: relative;
	width: 100%;
	max-width: 100%;
	height: auto;
	padding: 24px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const FooterRoot = styled(Box)`
	padding: 24px 20px;

	& button {
		margin-right: 20px;
	}

	& button:last-child {
		margin-right: 0;
	}
`;

export {
	HeaderRoot,
	FooterRoot,
};
